import TomSelect from "tom-select";


export default class GavDetail {
    constructor(form) {
        this.language = document.querySelector('html').lang;

        this.form = form;
        this.innerForm = this.form.querySelector('section.inner');
        this.formContainer = this.form.closest("section.gav-search");
        this.userSelectionWrapper = this.form.querySelector('.gavsearch-userselection');
        this.klauselnWrapper = this.form.querySelector('.gavsearch-klauseln');
        this.minimumSalaryWrapper = this.form.querySelector('.gavsearch-overview');
        this.formAction = undefined;
        this.apiKey = undefined;
        this.apiUrl = undefined;

        // user selection
        this.jobtitle = jobtitle;
        this.zipcode = zipcode;
        this.temporary = temporary;
        this.contractNumber = contractNumber;
        this.contractName = contractName;
        this.versionNumber = versionNumber;
        this.editionId = editionId;
        this.minsalaryLabels = [];
        if (minsalaryLabels.length > 0) {
            this.minsalaryLabels = JSON.parse(minsalaryLabels);
        }
        this.minsalaryData = minsalaryData;
        this.fileName = fileName;
        this.fileId = fileId;

        // Erstelle ein neues StreamReader-Objekt
        this.streamReader = null;
        this.chunks = [];

        if (this.formContainer) {
            this.initializeForm();
        }
    }

    initializeForm() {
        this.formAction = this.form.action;
        this.apiUrl = this.formContainer.dataset.apiurl;
        this.apiKey = this.formContainer.dataset.apikey;

        this.printUserSelection();
        this.getMinimumSalary();
        this.getKlauseln();
        this.getPdfData();
        this.setupAccordionScrolling();
    }

    printUserSelection() {
        let list = document.createElement('ul');
        list.classList.add('list-unstyled');
        let i = 0;
        this.minsalaryLabels.forEach((label) => {
            this.minsalaryData.forEach((data) => {
                if(label.id === data.CriteriaStructureId && data.Value !== null && data.Value !== '') {
                    let li = document.createElement('li');
                    li.innerHTML = '<strong>' + label.text + ':</strong> ' + data.Value;
                    list.appendChild(li);
                }
            });
        });

        this.userSelectionWrapper.querySelector('.minsalarylist').prepend(list);
    }


    getKlauseln() {

        let endpoint = `/api/contracts/${this.contractNumber}/versions/${this.versionNumber}/klauseln?language=${this.language}-ch`;
        let url = this.apiUrl + endpoint;

        let requestHeaders = new Headers({
            "Unia-Api-Key": this.apiKey,
            'Content-Type': 'application/json'
        });

        fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: requestHeaders
        })
        .then(response => response.json())
        .then(json => {
            if(json.success !== false && json.length > 0) {
                this.mapKlauseln(json);
            } else {
                console.warn('klauseln Query not successful:', json.message);

                // hide accordion when no data is present
                this.klauselnWrapper.classList.add('d-none');
            }
        }).catch((e)=>{
            console.warn('fetch error:', e);
            // hide accordion
            this.klauselnWrapper.classList.add('d-none');
        });
    }

    mapKlauseln(data) {
        let accordionStructure = [[], [], []];
        data.forEach((d) => {
            switch (d.klauselTyp) {
                case 'Überstunden / Überzeit':
                case 'Heures supplémentaires':
                case 'Lavoro straordinario / ore supplementari':

                case 'Nachtarbeit / Wochenendarbeit / Abendarbeit':
                case 'Travail de nuit / travail du week-end / travail du soir':
                case 'Lavoro notturno / lavoro al fine settimana / lavoro serale':

                case 'Spesenentschädigung':
                case 'Indemnisation des frais':
                case 'Rimborso spese':

                case 'Krankheit':
                case 'Maladie':
                case 'Malattia':

                    accordionStructure[0].push(d);
                    break;
                case 'Normalarbeitszeit':
                case 'Durée normale du travail':
                case 'Orario di lavoro':

                case 'Zuschlagrechner':

                case 'Mutterschafts- / Vaterschafts- / Elternurlaub':
                case 'Congé maternité / paternité / parental':
                case 'Congedo maternità / paternità / parentale':

                case 'Bezahlte arbeitsfreie Tage (Absenzen)':
                case 'Jours de congé rémunérés (absences)':
                case 'Giorni di congedo retribuiti (assenze)':

                case 'Milokonfig (Mindestlohnrechner)':
                    accordionStructure[1].push(d);
                    break;

                case 'Bildungsurlaub':
                case 'Congé de formation':
                case 'Congedo di formazione':

                case 'Kündigungsfrist':
                case 'Délai de congé':
                case 'Termini di disdetta':

                case 'Kündigungsschutz':
                case 'Protection contre les licenciements':
                case 'Protezione contro il licenziamento':

                case 'Frühpensionierung':
                case 'Retraite anticipée':
                case 'Pensionamento anticipato':
                    accordionStructure[2].push(d);
                    break;

                default:
                    // do nothing with all other klausel types
                    /**
                     * other known klausel types:
                     * "Vertragsdetails"
                     * "Vertragsnummer"
                     * "Vertragstyp"
                     * "Vertragsverantwortliche(r)"
                     * "Anzahl unterstellter Betriebe"
                     * "Anzahl unterstellter ArbeitnehmerInnen"
                     */
                    break;
            }
        });
        this.showKlauseln(accordionStructure);
    }

    showKlauseln(data) {
        let accordions = [
            this.klauselnWrapper.querySelector('.accordion-money'),
            this.klauselnWrapper.querySelector('.accordion-time'),
            this.klauselnWrapper.querySelector('.accordion-other')
        ];
        accordions.forEach((accordion, index) => {
            let html= '';

            if(data[index].length >= 1) {
                data[index].forEach((d) => {
                    html += `
                        <section class="klausel-section" id="klausel-${d.klauselId}">
                            <h3 class="klausel-title">${d.klauselTyp}</h3>
                            <div class="klausel-content">
                                ${d.klauselContents[0].value}
                            </div>
                        </section>
                    `;
                });
                accordion.querySelector('.accordion-body').innerHTML = html;
            } else {
                accordion.classList.add('d-none');
            }

        });
    }

    setupAccordionScrolling() {
        const accordionButtons = document.querySelectorAll('.accordion-button');
        const offset = document.querySelector('.page-header').offsetHeight;


        accordionButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                setTimeout(() => {
                    if (!event.target.classList.contains('collapsed')) {
                        window.scroll({
                            top: event.target.offsetTop - offset,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                }, 350);
            });
        });
    }

    getMinimumSalary() {
        if(this.minsalaryData !== undefined && this.minsalaryData.length !== 0) {
            try {
                let endpoint = `/api/minimumsalary/${this.editionId}/result?language=${this.language}-CH`;
                let url = this.apiUrl + endpoint;
                let requestHeaders = new Headers({
                    "Unia-Api-Key": this.apiKey,
                    'Content-Type': 'application/json'
                });
                let requestBody = JSON.stringify(this.minsalaryData);
                fetch(url, {
                    method: 'POST',
                    mode: 'cors',
                    headers: requestHeaders,
                    body: requestBody
                })
                    .then(response => response.json())
                    .then(json => {
                        if (json.success !== false) {
                            this.showMinimumSalary(json);
                        } else {
                            console.warn('Query not successful:', json.message);
                        }
                    }).catch((e) => {
                    console.warn('fetch error', e);
                    this.minimumSalaryWrapper.classList.add('d-none');
                    throw new Error('fetch error at minimumsalary result');
                });
            } catch (e) {
                console.warn('MinimumSalary Result fetch error: ', e);
            }
        } else {
            //no minsalaray data
            this.minimumSalaryWrapper.classList.add('d-none');
        }
    }

    showMinimumSalary(data) {
        let monthSalary = data.salary.monthSalary;
        let has13thMonthSalary = data.salary.has13thMonthSalary;
        let vacationDays = data.salary.vacationDays;
        let weekHours = data.salary.weekHours;

        this.minimumSalaryWrapper.querySelector('#month-salary').innerHTML = monthSalary;
        if(has13thMonthSalary) {
            this.minimumSalaryWrapper.querySelector('#has-13th-month-salary').innerHTML = '13';
        } else {
            this.minimumSalaryWrapper.querySelector('#has-13th-month-salary').innerHTML = '12';
        }
        this.minimumSalaryWrapper.querySelector('#vaccation-days').innerHTML = vacationDays;

        if(weekHours) {
            this.minimumSalaryWrapper.querySelector('#week-hours-text').innerHTML = weekHours;
            this.minimumSalaryWrapper.querySelector('.week-hours').classList.remove('d-none');
        }
    }

    getPdfData() {
        let endpoint = `/api/contractfile/${this.fileId}?language=${this.language}-CH`;
        let url = this.apiUrl + endpoint;
        let requestHeaders = new Headers({
            "Unia-Api-Key": this.apiKey,
            'Content-Type': 'application/json'
        });
        fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: requestHeaders
        })
        .then(response => {
            if(response.status == 200) {
                this.createDownloadablePdf(response.body);
            } else {
                console.warn('PDF Query not successful:', response.statusText);
            }
        }).catch((e)=>{
            console.log('fetch error', e);
        });
    }

    createDownloadablePdf(pdfStream) {
        this.streamReader = pdfStream.getReader();
        this.collectChunks();
    }

    // Definiere eine Funktion, die rekursiv alle Chunks aus dem Stream sammelt
    collectChunks() {
        this.streamReader.read().then(({ done, value }) => {
            if (done) {
                // Wenn alle Chunks aus dem Stream gesammelt wurden
                const pdfBlob = new Blob(this.chunks, { type: 'application/pdf' });
                const pdfUrl = URL.createObjectURL(pdfBlob);

                // Erstelle ein Link-Element, das auf das PDF verweist
                const downloadLink = document.createElement('a');
                downloadLink.href = pdfUrl;
                let linkname = this.fileName.replace(/\s+/g, '_');
                downloadLink.download = linkname + '.pdf';
                downloadLink.innerHTML = `
                    <div class="bg-light d-inline-flex flex-row align-items-center">
                        <div class="pdficon ps-4"><i class="icon-file-pdf"></i></div>
                        <div class="title px-3 py-4">${this.contractName}</div>
                        <div class="arrow pe-4"><i class="icon-arrow-down text-primary"></i></div>
                    </div>
                `;

                // Füge den Link zum Dokument hinzu
                document.querySelector('.gavsearch-pdfdownload').appendChild(downloadLink);
            } else {
                this.chunks.push(value);
                this.collectChunks();
            }
        });
    }
}

